import { errorToast } from "Components/Toasts";
import { errResponse } from "GenericForms/Helper";
import apiGlobal from "global/api.global";
import { useEffect, useState } from "react";
import { Modal } from "reactstrap";

interface Props {
    name: string;
    type: string;
    placeholder?: string;
    [x: string]: any
}

export const CustomLink = (props: Props) => {
    const [popUpState, setPopUpState] = useState(false);
    const [events, setEvents] = useState<Array<any>>([]);

    useEffect(() => {
        const loadLastRecord = async () => {
            apiGlobal.get(`/${props.popupPath}/`,
            ).then(res => {
                setEvents(res.data);
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
            return events;
        }; loadLastRecord();
    }, [props.popupPath, events]);

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_backdrop() {
        setPopUpState(!popUpState);
        removeBodyCss();
    }
    return (
        <>
            <label className="link_color_blue" onClick={tog_backdrop}>{props.placeholder}</label>
            <Modal
                isOpen={popUpState}
                toggle={() => {
                    tog_backdrop();
                }}
                backdrop={"static"}
                id="staticBackdrop"
            >
                <div className="modal-header">
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                            setPopUpState(false);
                        }}
                        aria-label="Close"
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="table-responsive ">
                        <table className="table mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>{props.popupColTitle}</th>
                                    <th>Next possible {props.popupType}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events.map((item: any, index: number) => {
                                    return (
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{item[props.popupTblField] + '-' + item[props.popupTblType] + '-' + item[props.popupTblState]}</td>
                                            <td>
                                                <div className="form-check mb-3">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`${index}`}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                            setPopUpState(false);
                        }}
                    >
                        Close
                    </button>
                    <button type="button" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </Modal>
        </>
    )
}
